/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import PropertyProvider from 'common/context/property'
import MessagesBanner from '../modules/messagesBanner'
import Breadcrumbs from '../modules/breadcrumbs'
import TransactionDetails from '../modules/transactionDetails'
import SimilarPropertiesCarousel from '../modules/similarProperties'
import HelpCenter from '../modules/helpCenter'
import SeoLinksFooter from '../modules/seoLinksFooter'
import Disclaimer from '../modules/disclaimer'
import { CancelledPropertyDescription } from '../modules/cancelledDescription'
import { ListingProvider } from '../context/listing'

const CancelledPropertyContainer = ({
  pageBannerRef,
  initialListing,
  property,
  propertyActions,
}) => {
  return (
    <PropertyProvider property={property} propertyActions={propertyActions}>
      <ListingProvider listing={initialListing}>
        <Breadcrumbs isCancelled />
        <MessagesBanner pageBannerRef={pageBannerRef} />
        <CancelledPropertyDescription listing={initialListing} />
        <SimilarPropertiesCarousel />
        <TransactionDetails />
        <HelpCenter />
        <Disclaimer />
        <SeoLinksFooter />
      </ListingProvider>
    </PropertyProvider>
  )
}

CancelledPropertyContainer.propTypes = {
  pageBannerRef: PropTypes.object,
  initialListing: PropTypes.object,
  property: PropTypes.object,
  propertyActions: PropTypes.object,
}

export default CancelledPropertyContainer
